<div *ngIf="isLoading" 
      class="show-loader loading-overlay" 
      automation-id="loading-icon">
 <img src="assets/images/loader.svg" />
</div>